import script from "./NewResetPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewResetPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./NewResetPasswordView.vue?vue&type=style&index=0&id=fa22357e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa22357e"]])

export default __exports__